import React, { useEffect, useState } from 'react';
import Plot from 'react-plotly.js';
// import WaterMark from '../DashboardMain_Bus/WaterMark';
// import './EnergyPageCustom_Bus.css'
import './GaugeChart.css'
import useHttp from '../../../hook/use-http';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';

const GaugeChartWithLyfCycle_Bus = (props) => {
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const { filterdata, apiEnd, packType } = props

    const { range_end, title, step_gap } = props
    const [data, setValue] = useState({ value: 0, cellId: 0, lastCycle: 0 })
    useEffect(() => {
        fetchData(
            {
                url: API_URL_MAIN + `battery_digital_twin/${apiEnd}`,
                body: { filterdata, packType },
            },
            (data) => {
                if (data[0]?.Min_Pack_RUL) {
                    let res = data[0]?.Top_Result?.hits?.hits[0]
                    setValue({ value: res?._source?.Pack_RUL, cellId: res?._source?.Min_RUL_Cell_ID, lastCycle: res?.fields?.LastCycle[0] })
                }
                if (!data.length) {
                    setValue({ value: 0, cellId: 0, lastCycle: 0 })
                }
            }
        );
    }, [props]);

    const config = {
        scrollZoom: true,
        showLink: false,
        modeBarButtonsToRemove: ['toImage', 'zoom2d', 'pan', 'pan2d', 'autoScale2d'],
        displayLogo: false,
        displayModeBar: false
    };

    return (
        <>
            <Plot
                data={[
                    {
                        type: 'indicator',
                        mode: 'gauge+number',
                        value: Number(data.value),
                        title: {
                            text: title, font: { size: 12, color: '#0E3157' }
                        },
                        number: {
                            valueformat: '0',
                        },
                        gauge: {
                            axis: {
                                range: [0, range_end],
                                tickwidth: 1,
                                tickcolor: "#83a4cf",
                                tick0: 0,
                                dtick: step_gap,
                                tickfont: { size: 10, color: 'black' }

                            },
                            // bar: { color: "rgba(0, 0, 0, 0)" },
                            bar: { color: "#83a4cf" },
                            borderwidth: 1,
                            bordercolor: 'gray',
                            steps: [
                                { range: [0, range_end], color: "whitex" },
                                { range: [0, range_end], color: 'white' },
                                // { range: [gauge_value, range_end], color: '#83a4cf', thickness: 0.5 },
                                { range: [0, data?.lastCycle], color: '#a8f080', thickness: 0.5, },
                                { range: [data?.lastCycle, Number(data?.lastCycle + data?.value)], color: "#83a4cf", thickness: 0.5, },
                            ],
                        }
                    }
                ]}
                layout={{
                    width: 270,
                    height: 195,
                    margin: { t: 25, b: 20, r: 50, l: 30 },
                    // annotations: [{
                    //     text: `Max of 208 cells, at cell Id = ${data?.cellId}`,
                    //     font: { size: 10, color: 'gray' },
                    //     showarrow: false,
                    //     x: 0.5,
                    //     y: 0.05
                    // }],
                }}
                config={config}
            />
        </>
    );
};

export default GaugeChartWithLyfCycle_Bus;
